import React from "react"
import { AlertTriangle, Loader2 } from "lucide-react"
import type { FeedbackPhase } from "../utils/feedbackPhase"

const FeedbackPhaseChip = ({ phase }: { phase: FeedbackPhase }) => {
  if (phase === "pending") {
    return (
      <span className="assessment-card__chip is-pending">
        <Loader2 size={12} className="is-spinning" /> Awaiting feedback
      </span>
    )
  }
  if (phase === "failed") {
    return (
      <span className="assessment-card__chip is-failed">
        <AlertTriangle size={12} /> Marking failed
      </span>
    )
  }
  return <span className="assessment-card__chip is-marked">AI Marked</span>
}

export default FeedbackPhaseChip
